/**
 * Feature flag keys used in the application.
 * These keys must match exactly with the flags configured in the PostHog dashboard.
 */
export const FeatureFlags = {
  PostSessionSurvey: "lotus-post-session-survey",
  PostHogSessionReplay: "lotus-posthog-session-replay",
} as const;

/**
 * Type representing all possible feature flag keys.
 */
export type FeatureFlagKey = (typeof FeatureFlags)[keyof typeof FeatureFlags];
